
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class ChooseGuide extends Mixins(MixinsHomeClick) {
  jumpers: string[] = ['beginner', 'first', 'second', 'third', 'fourth', 'fifth', 'sixth']

  get PageStore() {
    return this.$store.$storeActivitys.Calligraphy
  }

  toDetail(item: string) {
    const dataSource = this.PageStore.dataSource

    if (!dataSource || !dataSource.guide) return

    const target = dataSource.guide[item]

    if (!target) return

    if (target.event) {
      this.onClickEvent(target.event)
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
